<template>
    <span>{{ billable }}</span>
</template>

<script>
export default {
    name: 'BillableHandler',

    props: {
        status: {
            type: Number,
            required: false,
            default: 0,
        },
    },

    data() {
        return {
            billable: '',
        }
    },

    created() {
        this.billable = this.status === 1 ? 'OUI' : 'NON'
    },
}
</script>

<style scoped></style>
